/**
 * Our four tenants (Mandanten): their OASIS numbers and what customers see of them — name, website, the claims
 * mailbox and phone, and where a complaint goes.
 */
export const tenants = ['domcura', 'nordvers', 'innoas', 'asspario'];
/**
 * The tenant identifiers by their number.
 */
export const tenantIdentifiersByNumber = {
    1: 'domcura',
    2: 'nordvers',
    13: 'innoas',
    15: 'asspario',
};
/**
 * The OASIS tenant number of each tenant, as the string OASIS uses (`sepa_tenant_no`, `claim.oasisData.tenantNo`).
 */
export const tenantNumbers = {
    domcura: '1',
    nordvers: '2',
    innoas: '13',
    asspario: '15',
};
/**
 * Tenant details by tenant.
 */
export const tenantDetails = {
    domcura: {
        name: 'DOMCURA AG',
        website: 'https://www.domcura.de',
        email: {
            logo: {
                width: 198,
                height: 48,
            },
            address: 'DOMCURA Schaden <schaden@domcura.de>',
        },
        claimsPhone: '+49 431 54654-600',
        complaints: { channel: 'email', address: 'beschwerdemanagement@domcura.de' },
    },
    nordvers: {
        name: 'Nordvers GmbH',
        website: 'https://www.nordvers.com',
        email: {
            logo: {
                width: 206,
                height: 48,
            },
            address: 'Nordvers Schaden <schaden@nordvers.com>',
        },
        claimsPhone: '+49 431 54654-600',
        complaints: { channel: 'letter', address: 'Nordvers GmbH, Theodor-Heuss-Ring 49, 24113 Kiel' },
    },
    innoas: {
        name: 'innoAS GmbH',
        website: 'https://www.innoas.de',
        email: {
            logo: {
                width: 120,
                height: 48,
            },
            address: 'innoAS Schaden <schaden@innoas.de>',
        },
        claimsPhone: '+49 431 54654-685',
        complaints: {
            channel: 'letter',
            address: 'innoAS GmbH, Abteilung Beschwerdemanagement, Theodor-Heuss-Ring 49, 24113 Kiel',
        },
    },
    asspario: {
        name: 'asspario Versicherungsdienst GmbH',
        website: 'https://www.asspario.de',
        email: {
            logo: {
                width: 194,
                height: 48,
            },
            address: 'asspario Schaden <schaden@asspario.de>',
        },
        claimsPhone: '+49 671 88765-0',
        complaints: {
            channel: 'letter',
            address: 'asspario Versicherungsdienst GmbH, Riegelgrube 5a, 55543 Bad Kreuznach',
        },
    },
};
